import React from 'react';
import { observer } from 'mobx-react-lite';
import { toTextQuestionAnswer } from '../../stores/QuestionStore';
import { DisplayMode } from '../RenderForm';
import { EditTime } from './edit/EditTime';
import { ViewTime } from './view/ViewTime';
export const Time = observer(({
  id,
  questionStore,
  displayMode
}) => {
  const showEditComponent = displayMode === DisplayMode.Edit;
  if (showEditComponent) {
    var _questionStore$formQu, _questionStore$formQu2, _questionStore$formQu3;
    return /*#__PURE__*/React.createElement(EditTime, {
      id: id,
      value: toTextQuestionAnswer(questionStore.currentAnswer),
      isInvalid: !!questionStore.validationErrors,
      isRequired: (_questionStore$formQu = questionStore.formQuestion) === null || _questionStore$formQu === void 0 ? void 0 : (_questionStore$formQu2 = _questionStore$formQu.validation) === null || _questionStore$formQu2 === void 0 ? void 0 : _questionStore$formQu2.rq,
      onChange: value => {
        let returnValue = value;
        if (value.includes('am') || value.includes('pm')) {
          returnValue = value.slice(0, -2);
        }
        questionStore.setAnswer(returnValue);
      },
      label: (_questionStore$formQu3 = questionStore.formQuestion) === null || _questionStore$formQu3 === void 0 ? void 0 : _questionStore$formQu3.label
    });
  }
  return /*#__PURE__*/React.createElement(ViewTime, {
    id: id,
    value: toTextQuestionAnswer(questionStore.currentAnswer),
    displayMode: displayMode
  });
});